export default {"src":"/_next/static/media/CalendarIcon.5e50602b.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};